import { render, staticRenderFns } from "./CmgRewardsAchievementsBody.vue?vue&type=template&id=e2a169d2&scoped=true&lang=pug&"
import script from "./cmg-rewards-achievements-body.ts?vue&type=script&lang=ts&"
export * from "./cmg-rewards-achievements-body.ts?vue&type=script&lang=ts&"
import style0 from "./CmgRewardsAchievementsBody.vue?vue&type=style&index=0&id=e2a169d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a169d2",
  null
  
)

export default component.exports